export const CNAME = '/';
export const DASHBOARD = 'dashboard';
export const SUMMARY = 'summary';
export const ROUTES = 'routes';
export const process_id = ':processId';
// export const PROCESS_ID = ':optimization_id';
export const LOGIN = 'login';
export const RESET_PWD = 'password/reset/:key';
export const ACTIVATE_USER = 'activate/:key';
export const USER_PROFILE = 'profile';
export const SETTINGS_PAGE = "settings";
export const VEHICLE_EDITOR = "vehicles";
export const SHIPMENTS_SETTING = "shipment";
export const OPTIMIZATION_SETTING = "optimization"
export const GENERAL_SETTING = "general"
export const ROUTELIST = 'routelistmap';
export const TIMELINE = 'timeline';
export const ROUTE_ID = ':route_id';
export const TERRITORY = "territory";
// Pages whose last URL segment is the optimization id.
const PROCESS_PAGES = ['/dashboard', '/routes/timeline', '/routes/routelistmap', '/interactive'];

// Same page, different optimization — undefined when the page isn't per-process.
export const processPagePath = (pathname: string, processId: string) => {
  const page = PROCESS_PAGES.find(base => pathname.startsWith(base));
  return page && `${page}/${processId}`;
};
